export function getView(type) {
  // TODO: there will be some restructuring in this section
  // since we would like to aggregate similar data in a single entry
  switch (type) {
    case 'InstallmentCharge':
    case 'LateFeeCharge':
    case 'MiscFeeCharge':
    case 'RetailFeeCharge':
    case 'TransferCharge':
    case 'TxFeeCharge':
      return 'Charge'
    case 'ChargeTransfer':
    case 'DiscountAdjustment':
    case 'DiscountReverseAdjustment': // don't load this type of transaction (just mark the original discount as reverted)
    case 'FixAdjustment':
    case 'PaymentPlan':
    case 'PaymentPlanRollback': // don't load this type of transaction (just mark the original payment plan as reverted)
    case 'Refund':
    case 'WriteOff':
      return 'Adjustment'
    case 'payment':
    case 'unapplied_payment': // don't load this type of transaction (just mark the original payment plan as reverted)
      return 'Payment'
    default:
      return 'No'
  }
}
